import { Time } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { helperService } from 'src/app/utils/helper';
import { TimeRecord } from '../dashboards/timeRecord.model';
import { TimeRecordService } from './time-record.service';
import { HttpHeaders } from '@angular/common/http';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { LazyLoadEvent, MessageService, SelectItem } from 'primeng/api';
import Swal from 'sweetalert2';
import { matchModeOptionsDateList, task, timeRecord } from 'src/app/utils/filterDropDownData';
import { Table } from 'primeng/table';
import { AppConfigService } from '../app-config/app-config.service';
import { UsersGridService } from '../users-grid/users-grid.service';
import { FieldInfo, FieldInfoGridService } from '../field-info-grid/field-info-grid.service';
import { SavedTableState, TableStateService } from 'src/app/shared/table-state.service';

@Component({
    selector: 'app-time-record-grid',
    templateUrl: './time-record-grid.component.html',
    styleUrls: ['./time-record-grid.component.scss'],
    standalone: false
})
export class TimeRecordGridComponent implements OnInit {
  // v13-migration placeholder (Ivy basic template-check requires the symbol to exist; undefined at runtime == v12 behaviour; Phase 2: align template)
  errorMsg: any;
  @Input()
  dashboard: boolean = false;

  @Input()
  tasksgridPrjFilter: any = false;

  @Input()
  tasksgridTaskFilter: any = false;

  @Input() 
  tkdashboard:any = false;

  @Input()
  lpcdashboard:any = false;

  @ViewChild('dt') timeRecordTable!: Table;

  selectedRows: TimeRecord[] = [];
  timeRecords: TimeRecord[] = [];
  cols: any = [];
  userrole: any;
  totalRecords: number = 0;
  first: number = 0;
  public lastTableLazyLoadEvent: any = null;
  showTrDialog: Boolean = false;
  loading: Boolean = false;
  timeForm: any = {};
  lpcadminflag: boolean = false;
  showRejectField: boolean = false;
  filterOptions=timeRecord.filters;
  selectedFilterOption: string='All Time Records';
  title: String = "";
  acceptedDates:any;
  datefutureValid:boolean=true;
  viewonlyTR: boolean = false;
  billableList:any;
  timeRecStatusList:any;
  taskStatusList:any;
  rejectionInvalid:boolean=false;
  showrejectComment:boolean=false;
  onlylpcadmin:boolean=false;
  onlytk:boolean=false;
  enableMultiRejectBtn:boolean=false;
  combroles:boolean=false;
  statuscodes = ['INPROGRESS', 'INREVIEW', 'APPROVED', 'REJECTED']
  rejectComment:string=""
  rejectStandardReasonList=timeRecord.rejectStandardReasonList
  defaultTime: any;
  stateCodeMapList: any;
  timeRecordsDueDate:any;
  timeRecordsStartDate:any;
  projectStartDate:any;
  projectDueDate:any;
  timeClosingDate:any;
  searchTerm:string='';
  lastSearchTerm:any='';
  filterDatesMatchModes:any={taskDueDate:'dateIs',createdOn:'dateIs',date:'dateIs',exportDate:'dateIs',approveRejectOn:'dateIs'}
  filterDates:any={taskDueDate:null,createdOn:null,date:null,exportDate:null,approveRejectOn:null}
  dateFilters:any=[]
  matchModeOptionsDate: SelectItem[] =[
    { label: 'Date Is', value: 'dateIs' },
    { label: 'Date Before', value: 'ltDate' },
    { label: 'Date After', value: 'gtDate' },
    { label: 'Date Range', value: 'betweenDate' },
  ];
  loggedUser:any;
  trAction: 'REJECT' | 'SUBMIT' | null = 'SUBMIT';
  confirmMessage:string = '';
  showConfirmAlert:boolean = false;
  btnLoading:boolean = false;
  exportLoading:boolean = false;
  showRejectConfirmAlert:boolean = false;
  rejectReason:string= '';
  trLoadingSubscription:any;
  appConfigServiceSubscription:any;
  initialLoadDone:boolean = false;
  public defaultFilters: { [s: string]: any } = {};
  activeTab = 'default';  
  gridSettingsDialog: boolean = false;
  
  resetcustomFilter: boolean = false;
  defaultCols: any[] = [];
  customCols: any[] = [];
  availableColumns: any[] = [];
  tableCols: any[] = [];
  statuses:any;

  auditDialog: boolean = false;
  auditField:string="";
  auditRecordId:any;
  auditTitle:string="";
  auditTableName:string="";

  constructor(private filterService: helperService, private readonly messageService: MessageService, 
    private timeRecordService: TimeRecordService, public auth: AuthGuard,
    private appConfigService:AppConfigService,private cdr:ChangeDetectorRef,private userService:UsersGridService,
  private fieldInfoService:FieldInfoGridService,private tableStateService:TableStateService) { }

  ngOnInit(): void {
    if(this.tkdashboard||this.lpcdashboard)
     this.dashboard=true;
    this.userrole = this.auth.roles;
    this.defaultTime = new Date();
    this.defaultTime.setHours(0, 0, 0, 0);
    this.controlactions();
    this.stateCodeMapList=timeRecord.stateCodeMapList;
    this.tableCols = [
          { field: 'organizationName', header: 'Organization Name', filterType: 'text', visible: true,showHistoryIcon: false },
          { field: 'matterName', header: 'Matter Name', filterType: 'text', visible: true,showHistoryIcon: false },
          // { field: 'projectName', header: 'Project Name', filterType: 'text', visible: true },
          // { field: 'taskName', header: 'Task Name', filterType: 'text', visible: true },
          // { field: 'taskId', header: 'Task Id', filterType: 'numeric', visible: true },

          { field: 'date', header: 'Time Record Date', filterType: 'date', visible: true,showHistoryIcon: false },
          { field: 'isBillable', header: 'Billable', filterType: 'boolean', visible: true,showHistoryIcon: false },
          // { field: 'amountOfTime', header: 'Amount of Time', filterType: 'numeric', visible: true },
          { field: 'description', header: 'Description', filterType: 'text', visible: true,showHistoryIcon: false },

          { field: 'timeRecordStatus', header: 'Time Record Status', filterType: null, visible: true,showHistoryIcon: true },
          { field: 'approveRejectBy', header: 'Time Record Approved/Rejected By', filterType: 'text', visible: true,showHistoryIcon: false },
          { field: 'approveRejectOn', header: 'Time Record Approved/Rejected On', filterType: 'date', visible: true,showHistoryIcon: false },

          { field: 'createdBy', header: 'Created By', filterType: 'text', visible: true,showHistoryIcon: false },
          { field: 'createdOn', header: 'Created Date', filterType: 'date', visible: true,showHistoryIcon: false },

          { field: 'taskDueDate', header: 'Due Date', filterType: 'date', visible: true,showHistoryIcon: true },
          { field: 'isCompleted', header: 'Task Completed', filterType: 'boolean', visible: true,showHistoryIcon: true },
          { field: 'taskStatusCode', header: 'Task Status', filterType: null, visible: true,showHistoryIcon: true },

          { field: 'stateCode', header: 'State', filterType: null, visible: true,showHistoryIcon: false },
          { field: 'tkComment', header: 'Time Record Comments', filterType: 'text', visible: true,showHistoryIcon: false },
          { field: 'rejectReason', header: 'Rejection Reason', filterType: null, visible: true,showHistoryIcon: false },

          { field: 'exportDate', header: 'Exported On', filterType: 'date', visible: true,showHistoryIcon: false },
          { field: 'enteredTime', header: 'Time Spent', disableActions: true, visible: true,showHistoryIcon: false }
        ];
    this.cols=this.tableCols;
    this.fetchColumnSettings();
    this.taskStatusList=timeRecord.taskStatusList;
    this.billableList=timeRecord.billableList;
    this.timeRecStatusList=timeRecord.timeRecStatusList;
    this.statuses = task.statuses;

    this.timeForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      taskName: new UntypedFormControl(''),
      taskId:new UntypedFormControl(''),
      projectName: new UntypedFormControl(''),
      projectId: new UntypedFormControl(''),
      organizationName: new UntypedFormControl(''),
      matterName: new UntypedFormControl(''),
      qbTaskId: new UntypedFormControl(''),
      timeEstimate: new UntypedFormControl(''),
      actualTime: new UntypedFormControl(''),
      isEnforceMaximum: new UntypedFormControl(''),
      projectStartDate: new UntypedFormControl(''),
      stateCode: new UntypedFormControl(''),
      country: new UntypedFormControl(''),
      isCompleted: new UntypedFormControl(''),
      isBillable: new UntypedFormControl(''),
      includeToday: new UntypedFormControl(''),
      consolidatedTimeRecords: new UntypedFormControl(''),
      isRequireEstimate: new UntypedFormControl(''),
      statusCode: new UntypedFormControl(''),
      isApprovalRequired: new UntypedFormControl(''),
      taskDueDate: new UntypedFormControl(''),
      projectDueDate: new UntypedFormControl(''),
      openEnded: new UntypedFormControl(''),
      quantityState: new UntypedFormControl([]),
      quantityNumber: new UntypedFormControl(''),
      quantity: new UntypedFormControl(''),
      quantityType: new UntypedFormControl(''),
      quantityRelated: new UntypedFormControl(''),
      maxTime: new UntypedFormControl(''),
      rateTypeCode: new UntypedFormControl(''),
      isStateRelated: new UntypedFormControl(''),
      countryRelated: new UntypedFormControl(''),
      createdOn: new UntypedFormControl(''),
      dueDaySlot: new UntypedFormControl(''),
      enteredTime: new UntypedFormControl(''),
      approver: new UntypedFormControl(''),
      approved: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      timeRecordStatus: new UntypedFormControl(''),
      taskCompleted: new UntypedFormControl(''),
      timeRecordDueDate: new UntypedFormControl(''),
      date:new UntypedFormControl(''),
      loggedTime: new UntypedFormControl(''),
      rejectComment: new UntypedFormControl(''),
      rejectReason: new UntypedFormControl(''),
      stateDesc:new UntypedFormControl(''),
      tkComment:new UntypedFormControl(''),
      taskAssignmentId:new UntypedFormControl(''),
      isReadyToComplete:new UntypedFormControl(''),
      approveRejectOn:new UntypedFormControl(''),
      approveRejectBy:new UntypedFormControl(''),
      disableApproveBtn:new UntypedFormControl(''),
      quantityStr:new UntypedFormControl(''),
      disableTrSelectionTitle:new UntypedFormControl(''),
      disableApproveBtnTitle: new UntypedFormControl(''),
      disableAcceptRejectFlagTitle: new UntypedFormControl(''),
      exportDate: new UntypedFormControl(''),
      completedChangeCount: new UntypedFormControl(''),
      statusChangeCount: new UntypedFormControl(''),
      dueDateChangeCount: new UntypedFormControl('')
    });

    const savedTableState = this.tasksgridPrjFilter ? null : this.tableStateService.getState('timerecord_grid'+this.activeTab,this.auth.jwtData.email);
    if(savedTableState && !this.initialLoadDone){
      this.restoreSavedState(savedTableState);
    }
    this.cdr.detectChanges();

  }
  

  controlactions() {

    if (this.userrole.includes("LPC") || this.userrole.includes("ADMIN")) {
      this.enableMultiRejectBtn= true;
    }
    if (this.filterService.isOnlyTKUser(this.userrole)) {
      this.onlytk=true;
      return;
    }
    if (this.userrole.includes("LPC") || this.userrole.includes("ADMIN")) {
      // this.lpcadminflag = true;
      if(this.userrole.includes("TK")){
        this.combroles=true;
      }
      else{
        this.onlylpcadmin=true;
      }
    }
  }
  convertTime(time: any) {
    const date = new Date();
    const [hours, minutes] = (String(Math.floor(time / 60)) + ':' + String(time % 60)).split(':');
    date.setHours(Number(hours), Number(minutes));
    return date
  }

  async getLoginUserMail(): Promise<void> {
    if(this.loggedUser) return;
    try {
        const res: any = await this.userService.getLoginUser().toPromise();
        this.loggedUser = res?.rows ;
    } catch (error) {
        console.error("Error fetching login user details:", error);
    }
}

  async buildTimeRecordPayload(event: any): Promise<any> {
    await this.getLoginUserMail();
    let payload = this.filterService.generateEventPayload(event);

    // Add category-specific filters
    if (this.selectedFilterOption == 'My Time Records') {
      payload["category"] = "My Time Records";
      payload.filters.push({
        "field": "createdBy",
        "operator": "equals",
        "value": this.auth.jwtData.email,
        "logicGrp": "OR"
      });
    } else if (this.selectedFilterOption == 'All Time Records') {
      payload["category"] = "All Time Records";
    } else if (this.selectedFilterOption == 'My Approval TimeRecords') {
      payload["category"] = "My Time Records";
      payload.filters.push({
        "field": "approver",
        "operator": "equals",
        "value": this.loggedUser?.id,
      });
      payload.filters.push({
        "field": "timeRecordStatus",
        "operator": "in",
        "values": ["In Review"]
      });
      // payload.filters.push({
      //   "field": "taskStatusCode",
      //   "operator": "in",
      //   "values": ["Ready To Complete"]
      // });
    }

    // Add project filter if exists
    if (this.tasksgridPrjFilter) {
      payload.filters.push({
        "field": "projectId",
        "operator": "equals",
        "value": this.tasksgridPrjFilter
      });
    }

    if (this.tasksgridTaskFilter) {
      payload.filters.push({
        "field": "taskId",
        "operator": "equals",
        "value": this.tasksgridTaskFilter
      });
    }

    // Add date filters
    if (this.dateFilters) {
      payload.filters = payload.filters.concat(this.dateFilters);
    }

    // Add search term
    payload["searchTerm"] = this.searchTerm;

    return payload;
  }

  async loadTimeData(event: any,table?:Table) {
    this.saveState(event);
    this.lastTableLazyLoadEvent = event;
    this.loading = true;
    if(table){
      table._first=0;
      event.first =  1;
      event.rows =  10;
    }else{
      event.first = event.first ? event.first : 1;
      event.rows = event.rows ? event.rows : 10;
    }
    
    let payload = await this.buildTimeRecordPayload(event);
    this.timeRecords = [];
    
    if( this.appConfigServiceSubscription)  
      this.appConfigServiceSubscription.unsubscribe();
    this.appConfigServiceSubscription=this.appConfigService.getConfigurationsById(null).subscribe(res=>{
      let data=res.data.filter((obj:any)=>obj.name=="Time Closing Date");
      this.timeClosingDate=data.length>0 &&data[0].value?new Date(data[0].value):new Date();
    })

    if(this.searchTerm){
      event.first =1
    }
    if(this.lastSearchTerm!=this.searchTerm){
      event.first =1
    }
    this.lastSearchTerm=this.searchTerm;

    if(this.trLoadingSubscription)
      this.trLoadingSubscription.unsubscribe();
    this.trLoadingSubscription=this.timeRecordService.getTimeRecordsList(Math.floor(event.first / event.rows + 1), event.rows, this.filterService.useDashboardUrl(this.auth.roles,this.tkdashboard),payload).subscribe(res => {
      
      console.log(this.loggedUser);
      let list = res.data;
      let tempRecords: TimeRecord[] = [];
      list.forEach((element: any) => {
        let disableTrSelection = true;
        let disableTrSelectionTitle = '';
        let disableAcceptRejectFlag = true;
        let disableAcceptRejectFlagTitle = '';
        let disableEditFlag = false;
        let disableEditFlagTitle = '';
        let disableApproveBtn = false;
        let disableApproveBtnTitle = '';

        // Selection logic
        if (element.timeRecStatus === 'In Progress' ) {
          disableTrSelection = false;
          disableTrSelectionTitle = '';
        } else {
          disableTrSelection = true;
          disableTrSelectionTitle = 'Only In Progress records can be selected.';
        }

        // Accept/Reject logic
        if (
          this.userrole.includes('Approver') &&
          (element.timeRecStatus === 'In Review' || element.timeRecStatus === 'Approved') &&
          (
            (this.loggedUser?.approvePracticeAreaCodes?.filter((description: any) => description == element.alProjectTask.practiceAreaCode).length > 0) ||
            (this.loggedUser?.approveUsersId?.includes(element.alUser.id))
          )
        ) {
          disableAcceptRejectFlag = false;
          disableAcceptRejectFlagTitle = '';
        } else if (element.alProject.closedDate && this.filterService.isPastDate(new Date(element.alProject.closedDate))) {
          disableAcceptRejectFlag = true;
          disableAcceptRejectFlagTitle = 'Project is closed. Action not allowed.';
        } else if (this.userrole.includes('ADMIN')) {
          disableAcceptRejectFlag = false;
          disableAcceptRejectFlagTitle = '';
        } else if (element.exportStatus?.toUpperCase() === 'YES') {
          disableAcceptRejectFlag = true;
          disableAcceptRejectFlagTitle = 'Exported records cannot be approved or rejected.';
        } else {
          disableAcceptRejectFlag = true;
          disableAcceptRejectFlagTitle = 'You do not have permission to approve/reject this record.';
        }

        // Edit logic
        if (element.timeRecStatus?.toUpperCase() === 'REJECTED' && ["Excessive Time", "Poor Description"].includes(element.rejectReason)) {
          disableEditFlag = false;
          disableEditFlagTitle = '';
        }
        else if (element.timeRecStatus !== 'In Progress') {
          disableEditFlag = true;
          disableEditFlagTitle = 'Only In Progress records can be edited.';
        } else if (element.exportStatus?.toUpperCase() === 'YES') {
          disableEditFlag = true;
          disableEditFlagTitle = 'Exported records cannot be edited.';
        } else {
          disableEditFlag = false;
          disableEditFlagTitle = '';
        }

        // --- Approve button logic ---
        if (element.exportStatus?.toUpperCase() === 'YES') {
          disableApproveBtn = true;
          disableApproveBtnTitle = 'Exported records cannot be approved.';
        } else if (this.userrole.includes('ADMIN') && element.exportStatus?.toUpperCase() !== 'YES' && element.approveRejectBy) {
          disableApproveBtn = true;
          disableApproveBtnTitle = 'Already approved/rejected by someone else.';
        } else if (
          (element.timeRecStatus?.toUpperCase() !== 'REJECTED') &&
          this.loggedUser?.approveUsersId?.includes(element.alUser.id) &&
          element.exportStatus?.toUpperCase() !== 'YES' &&
          element.approveRejectBy
        ) {
          disableApproveBtn = true;
          disableApproveBtnTitle = 'You cannot approve this record as it is already approved/rejected.';
        } else if (
          this.userrole.includes('ADMIN') &&
          element.timeRecStatus?.toUpperCase() !== 'REJECTED' &&
          element.approveRejectBy &&
          element.approveRejectBy?.toUpperCase() === 'SYSTEM'
        ) {
          disableApproveBtn = true;
          disableApproveBtnTitle = 'This record was processed by the system and cannot be approved.';
        } else {
          disableApproveBtn = false;
          disableApproveBtnTitle = '';
        }

        // Exported record disables
        if (element.exportStatus?.toUpperCase() === 'YES') {
          disableAcceptRejectFlag = true;
          disableAcceptRejectFlagTitle = 'Exported records cannot be approved or rejected.';
          disableEditFlag = true;
          disableEditFlagTitle = 'Exported records cannot be edited.';
        }

        let obj: any = {};
        obj["disableTrSelection"] = disableTrSelection;
        obj["disableTrSelectionTitle"] = disableTrSelectionTitle;
        obj["organizationName"] = element.alProjectTask.orgName;
        obj["matterName"] = element.alMatter.name;
        obj["projectName"] = element.alProject.name;
        obj["projectId"] = element.alProject.id;
        obj["taskName"] = element.alProjectTask.taskName;
        obj["taskId"] = element.alProjectTask.id;
        obj["quantityType"] = element.alProjectTask.quantityType;
        obj["isPrePaid"] = element.alProjectTask.isPrePaid;
        obj["isPreInvoiced"] = element.alProjectTask.isPreInvoiced;
        obj["quantityRelated"] = element.alProjectTask.quantityRelated;
        obj["createdBy"] = element.createdBy;
        obj["quantity"] = element.quantity;
        obj["taskAssignmentId"] = element.taskAssignmentId;
        obj["quantityState"] = element.quantity && element.alProjectTask.quantityType?.toUpperCase() == "STATE" ? element.quantity.split(",") : [];
        obj["taskDueDate"] = element.alProjectTask.taskDueDate;
        obj["createdOn"] = element.createdOn;
        obj["taskStatusCode"] = element.alProjectTask.statusCode;
        obj["isReadyToComplete"] = element.alProjectTask.statusCode === "Ready to Complete" ? true : false;
        obj["isBillable"] = element.alProjectTask.isBillable;
        obj['includeToday'] = element.alProjectTask.includeToday;
        var hours = Math.floor(element.enteredTime / 60);
        var minutes = element.enteredTime % 60;
        let date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        obj["enteredTime"] = date;
        obj["amountOfTime"] = element.enteredTime;
        obj["description"] = element.description;
        obj["date"] = element.date;
        obj["timeRecordStatus"] = element.timeRecStatus;
        obj["taskCompleted"] = element.alProjectTask.isCompleted ;
        obj["isCompleted"]= element.alProjectTask.isCompleted;
        obj["id"] = element.id;
        obj['loggedTime'] = this.convertTime(element.alProjectTask.timeRecordsLoggedTime);
        obj['maxTime'] = this.convertTime(element.alProjectTask.maxTime);
        obj['timeEstimate'] = this.convertTime(element.alProjectTask.timeEstimate);
        obj['isRequireEstimate'] = element.alProjectTask.isRequireEstimate;
        obj['dueDaySlot'] = element.alProjectTask.dueDaySlot ? element.alProjectTask.dueDaySlot : '-';
        obj['rejectComment'] = element.rejectComment;
        obj['rejectReason'] = element.rejectReason;
        obj['tkComment'] = element.tkComment;
        obj['isEnforceMaximum'] = element.alProjectTask.isEnforceMaximum;
        obj['acceptedDates'] = element.alProjectTask.acceptedDates;
        obj['stateDesc'] = element.alProjectTask.stateDesc;
        obj['openEnded'] = element.alProjectTask.openEnded;
        obj['stateCode'] = element.alProjectTask.stateCode;
        obj['projectStartDate'] = element.alProject.startDate ? new Date(element.alProject.startDate):null;
        obj['projectDueDate'] = element.alProject.dueDate ? new Date(element.alProject.dueDate):null;
        obj['disableAcceptRejectFlag'] = disableAcceptRejectFlag;
        obj['disableAcceptRejectFlagTitle'] = disableAcceptRejectFlagTitle;
        obj['disableEditFlag'] = disableEditFlag;
        obj['disableEditFlagTitle'] = disableEditFlagTitle;
        obj['disableApproveBtn'] = disableApproveBtn;
        obj['disableApproveBtnTitle'] = disableApproveBtnTitle;
        obj['disableTrSelection'] = disableTrSelection;
        obj['disableTrSelectionTitle'] = disableTrSelectionTitle;
        obj['approveRejectOn'] = element.approveRejectOn;
        obj['approveRejectBy'] = element.approveRejectBy;
        obj['exportDate'] = element.exportDate ;
        obj['statusChangeCount'] = 1;
        obj['dueDateChangeCount'] = 1;
        obj['completedChangeCount'] = 1;
        tempRecords.push(obj);
      });
      this.timeRecords = tempRecords;
      this.loading = false;
      this.totalRecords = res.customValues.totalNumberOfRecords;
      this.cdr.detectChanges();
    })
  }
  closeDialog() {
    this.selectedRows = [];
    this.viewonlyTR = false;
    this.showTrDialog = false;
    this.showRejectField= false;
    this.showConfirmAlert=false;
    this.showRejectConfirmAlert= false;
    this.trAction=null;
    this.confirmMessage='';
    this.rejectReason = '';
    this.loadTimeData(this.lastTableLazyLoadEvent);
    this.cdr.detectChanges();
  }


  openViewTimeRecord(timeRecord: any) {
    timeRecord.includeToday=this.filterService.getflagBoolean(timeRecord.includeToday);
    timeRecord.isBillable=this.filterService.getflagBoolean(timeRecord.isBillable);
    timeRecord.taskCompleted=this.filterService.getflagBoolean(timeRecord.taskCompleted);
    timeRecord.isRequireEstimate=this.filterService.getStrBoolean(timeRecord.isRequireEstimate);
    timeRecord.isEnforceMaximum=this.filterService.getflagBoolean(timeRecord.isEnforceMaximum);
    timeRecord.isCompleted=this.filterService.getflagBoolean(timeRecord.isCompleted);
    timeRecord.quantityStr=timeRecord.quantity?timeRecord.quantity.toString():"";
    this.showTrDialog = true;
    this.viewonlyTR=true;
    this.acceptedDates=timeRecord.acceptedDates;
    this.title = "Time Record : " + timeRecord.taskName
    this.timeForm.patchValue(timeRecord);
    this.timeForm.disable();
    if(timeRecord.rejectComment!=null){
      this.showrejectComment=true;
    }
  }
  openEditTimeRecord(timeRecord: any) {
    timeRecord.includeToday=this.filterService.getflagBoolean(timeRecord.includeToday);
    timeRecord.isBillable=this.filterService.getflagBoolean(timeRecord.isBillable);
    timeRecord.taskCompleted=this.filterService.getflagBoolean(timeRecord.taskCompleted);
    timeRecord.isRequireEstimate=this.filterService.getStrBoolean(timeRecord.isRequireEstimate);
    timeRecord.isEnforceMaximum=this.filterService.getflagBoolean(timeRecord.isEnforceMaximum);
    timeRecord.isCompleted=this.filterService.getflagBoolean(timeRecord.isCompleted);
    timeRecord.quantityStr=timeRecord.quantity?timeRecord.quantity.toString():"";
    this.showTrDialog = true;
    this.title = "Time Record : " + timeRecord.taskName
    this.timeForm.patchValue(timeRecord);
    this.timeForm.disable();
    this.viewonlyTR = false;
    this.acceptedDates=timeRecord.acceptedDates;
    // this.timeForm.controls['isBillable'].value = timeRecord.isBillable
    this.timeForm.controls['isBillable'].enable();
    // this.timeForm.controls['taskCompleted'].enable();
    this.timeForm.controls['timeRecordDueDate'].enable();
    this.timeForm.controls['date'].enable();
    this.timeForm.controls['enteredTime'].enable();
    this.timeForm.controls['rejectComment'].enable();
    this.timeForm.controls['rejectReason'].enable();
    this.timeForm.controls['quantity'].disable();
    this.timeForm.controls['description'].enable();
    this.timeForm.controls['quantityType'].enable();
    this.projectStartDate=timeRecord.projectStartDate;
    this.projectDueDate=timeRecord.projectDueDate;
    this.timeRecordsStartDate=timeRecord.projectStartDate;
    if(this.timeForm.controls["rejectComment"].value!=null){
      this.showrejectComment=true;
    }
    if(this.timeForm.controls['quantityType'].value=="Number"){
      this.timeForm.controls['quantity'].enable();
    }else{
      this.timeForm.controls['quantityState'].enable();
    }
    if (timeRecord.isPreInvoiced === 'Yes' && timeRecord.isPrePaid === 'Yes' && timeRecord.quantityRelated == 'Yes' && timeRecord.quantityType) {
      this.timeForm.controls['quantity'].disable()
      this.timeForm.controls['quantityState'].disable()
      this.timeForm.controls['quantityStr'].disable()
      this.timeForm.controls['quantityNumber'].disable()
      this.messageService.clear();
      setTimeout(() => {
        this.messageService.add({ severity: 'info', detail: 'This is a prepaid project and you cannot modify the quantity.  If you need to increase the quantity, please contact the project administrator to add and assign a new Task to increase quantity.' });
      }, 100);
    }
    this.timeForm.controls['tkComment'].enable();
      //quantity enable based on task qyantityType
    this.validateTrRange()
  }

  validateTrRange(){
    const timeclosingDate=new Date(this.timeClosingDate);
    const today=new Date()

    let trstart=timeclosingDate;
    let trend=this.projectDueDate;

    if(timeclosingDate.getTime()<this.projectStartDate.getTime()){
      trstart=this.projectStartDate;
    }

    if(this.projectDueDate.getTime()>today.getTime()){
      trend=today;
    }
    
    this.timeRecordsStartDate=trstart
    this.timeRecordsDueDate=trend
    console.log(this.timeRecordsStartDate)
    console.log(this.timeRecordsDueDate)
  }

  openApproveTimeRecord(timeRecord: any) {
    
    timeRecord.includeToday=this.filterService.getflagBoolean(timeRecord.includeToday);
    timeRecord.isBillable=this.filterService.getflagBoolean(timeRecord.isBillable);
    timeRecord.taskCompleted=this.filterService.getflagBoolean(timeRecord.taskCompleted);
    timeRecord.isRequireEstimate=this.filterService.getStrBoolean(timeRecord.isRequireEstimate);
    timeRecord.isEnforceMaximum=this.filterService.getflagBoolean(timeRecord.isEnforceMaximum);
    timeRecord.isCompleted=this.filterService.getflagBoolean(timeRecord.isCompleted);
    timeRecord.quantityStr=timeRecord.quantity?timeRecord.quantity.toString():"";
    this.showTrDialog = true;
    this.title = "Time Record : " + timeRecord.taskName
    this.acceptedDates=timeRecord.acceptedDates;
    this.timeForm.patchValue(timeRecord);
    this.timeForm.disable();
    // this.timeForm.controls['description'].enable();
    this.timeForm.controls['rejectComment'].enable();
    this.timeForm.controls['rejectReason'].enable();
  }

  updateTR(status: any) {
    let timeFormObj = this.timeForm.getRawValue();
    // let time = timeFormObj.enteredTime.getHours() * 60 + timeFormObj.enteredTime.getMinutes() +timeFormObj.loggedTime.getHours()*60+timeFormObj.loggedTime.getMinutes();
    let time= this.filterService.convertDateToTime(timeFormObj.enteredTime);
    let existingTaskLogTime= this.filterService.convertDateToTime(timeFormObj.loggedTime);
    let maxTime = timeFormObj.maxTime ? timeFormObj.maxTime.getHours() * 60 + timeFormObj.maxTime.getMinutes() :
      timeFormObj.timeEstimate.getHours() * 60 + timeFormObj.timeEstimate.getMinutes();
    this.datefutureValid = new Date(timeFormObj.date)<=new Date()  ? true : false;
    
    let payload:any = {
      // "date": this.filterService.convertDateToFormattedStr(timeFormObj.timeRecordDueDate),//timeFormObj.timeRecordDueDate,
      "tkComment":timeFormObj.tkComment,
      "date":timeFormObj.date,
      "description": timeFormObj.description,
      "enteredTime": time,
      "billable": this.filterService.getflagBoolean(timeFormObj.isBillable),
      "taskCompleted": this.filterService.getflagBoolean(timeFormObj.taskCompleted),
      "status": this.statuscodes[Number(status)],
      "rejectComment": timeFormObj.rejectComment?timeFormObj.rejectComment:"",
      "rejectReason": timeFormObj.rejectReason?timeFormObj.rejectReason:"",
      "taskAssignmentId":timeFormObj.taskAssignmentId
    };
    if(timeFormObj.quantityType=="Number"){
      if(((typeof timeFormObj.quantity=="string" && isNaN(timeFormObj.quantity)) 
            ||!timeFormObj.quantity 
            || timeFormObj.quantity<=0) 
          && timeFormObj.quantityRelated=='Yes'){
        this.messageService.add({ severity: 'error', detail: 'Please enter valid Quantity number (should be greater than zero)!' });
        return;
      }else{
        payload['quantity']=timeFormObj.quantity
      }
    }else{
      if((!timeFormObj.quantityState || timeFormObj.quantityState.length<=0) && timeFormObj.quantityRelated=='Yes'){
        this.messageService.add({ severity: 'error', detail: 'Please select atleast one Quantity state!' });
        return;
      }else{
        payload['quantity']=timeFormObj.quantityState.join(",")
      }
    }
    
    // if(this.datefutureValid){
    if (timeFormObj.isEnforceMaximum){
    if (maxTime && time <= maxTime || this.filterService.getStrBoolean(timeFormObj.openEnded)=="Yes") {
      this.timeRecordService.updateTR(payload, this.timeForm.controls.id.value).subscribe(res => {
        if (res.message == "Success.") {
          this.closeDialog();
        }
        else{
          this.messageService.add({ severity: 'error', detail: res.message });
        }
      }, res => {
        this.messageService.add({ severity: 'error', detail: res.error.message });
      });
    }
    else {
      this.messageService.add({ severity: 'error', detail: 'The total logged time must not exceed the max time or estimated time.' });
    }}
    else{
      this.timeRecordService.updateTR(payload, this.timeForm.controls.id.value).subscribe(res => {
        if (res.message == "Success.") {
          this.closeDialog();
        }else{
          this.messageService.add({ severity: 'error', detail: res.message });
        }
      }, res => {
        this.messageService.add({ severity: 'error', detail: res.error.message });
      });
    }
  // }
  // else{
  //   this.messageService.add({ severity: 'error', detail: 'No future Date allowed!' });
    
  }
  /** Reason the dialog Approve button is disabled; '' when it is enabled. */
  getApproveDisabledReason(): string {
    if (this.showRejectField) {
      return 'Cannot approve while Reject is checked';
    }
    const form = this.timeForm.getRawValue();
    if (form.disableApproveBtn) {
      return form.disableApproveBtnTitle || 'Approval is not allowed for this record.';
    }
    if (this.timeForm.value.isReadyToComplete === false) {
      return 'Task is not ready to complete';
    }
    return '';
  }
  approve(approveFlag: boolean) {
    if(!approveFlag){
      if(this.timeForm.controls.rejectComment.value==null || this.timeForm.controls.rejectReason.value==null ||this.timeForm.controls.rejectReason.value==''){
          this.rejectionInvalid=true;
          return;
      } 
    }
    let payload:any={
      "timeRecords" : [
          {
              "timeRecordId" : this.timeForm.controls.id.value,
              "status" : approveFlag?"APPROVED":"REJECTED",
              "description":this.timeForm.controls.description.value,
              "rejectComment" :  this.timeForm.controls.rejectComment.value,
              "rejectReason" :  this.timeForm.controls.rejectReason.value,
              "tkComment" :  this.timeForm.controls.tkComment.value,
              "quantity":this.timeForm.controls.quantityType.value=="Number"?this.timeForm.controls.quantity.value:this.timeForm.controls.quantityState.value.join(",")
          }
      ]
    }
    
    
    this.timeRecordService.submitMultiple(payload).subscribe(res => {
      res=res && res.data?res.data[0]:{}
      try {
        if(res.statusCode==200 || res.message?.toUpperCase()=="SUCCESS"|| res.message?.toUpperCase()=="SUCCESS."){
          this.closeDialog();
          Swal.fire(payload.timeRecords[0].status);
          this.selectedRows = [];
          this.loadTimeData(this.lastTableLazyLoadEvent);
        }else{
          this.messageService.add({ severity: 'error', detail: res.message });
        }
      } catch (error) {
        this.messageService.add({ severity: 'error', detail: "Something went wrong..!" });
      }
    }, res => {
      this.messageService.add({ severity: 'error', detail: res.error.message });
    });
  }

  submitMultiple(persistFlag?: boolean) {
    if(!persistFlag){
      this.trAction="SUBMIT";
      this.showConfirmAlert=true;
      this.confirmMessage = "Are you sure you want to submit the Time?";
      return;
    }
    this.btnLoading=true;
    
    let list: any[] = []
    let payload = { "timeRecords": list };
    if (this.selectedRows.length > 0) {
      this.selectedRows.forEach((val: any) => {
        let obj: any = {};
        obj["timeRecordId"] = val.id;
        obj["status"] = 'INREVIEW';
        payload.timeRecords.push(obj);
      })
      this.timeRecordService.submitMultiple(payload).subscribe(res => {
        this.btnLoading=false;
        if(res.statusCode==200 || res.message?.toUpperCase()=="SUCCESS"|| res.message?.toUpperCase()=="SUCCESS."){
          Swal.fire("Time Submitted to In Review");
        }else{
          Swal.fire(res.message);
        }
        this.closeDialog();
      });
    }
  }
  rejectMultiple(persistFlag?:Boolean) {
    this.messageService.clear();

    if(!persistFlag){
      this.trAction="REJECT";
      this.showRejectConfirmAlert=true;
      this.confirmMessage = "Are you sure you want to reject the Time?";
      return;
    }
    if(!this.rejectReason || this.rejectReason.trim()==''){
      this.messageService.add({ severity: 'error', detail: 'Please enter rejection reason!' });
      return;
    }
    this.btnLoading=true;

    let payload = this.selectedRows.map((row: any) => ({
              timeRecordId: row.id,
              rejectReason: row.rejectReason // or use this.rejectReason if it's a common reason
            }));
  
    this.timeRecordService.rejectMultiple(payload).subscribe(res => {
      this.btnLoading=false;
      if(res.statusCode==200 || res.message?.toUpperCase()=="SUCCESS"|| res.message?.toUpperCase()=="SUCCESS."){
        Swal.fire("Time Rejected Successfully");
        this.rejectReason = '';
      }else{
        Swal.fire(res.message);
      }
      this.closeDialog();
    });
    
  }

  submit_reject_multiple(confirmFlag: boolean) {
    if (confirmFlag) {
      if (this.trAction == 'SUBMIT') {
        this.submitMultiple(true);
      } else {
        this.rejectMultiple(true);
      }
    }else{
      this.closeDialog();
    }
  }

  deleteTR(rows: any) {
    let list: any[] = [];
    rows.forEach((val: any) => {
      list.push(val.id);
    })
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        timeRecordIds: list
      },
    };

    this.timeRecordService.deleteTR(options).subscribe(res => {
      this.selectedRows = [];
      this.loadTimeData(this.lastTableLazyLoadEvent);
    });
  }

  rejectionClicked(event: any) {
    this.showRejectField = event.target.checked
  }

  handleTabChange(table: Table, event: any) {
    this.loading=true;
    this.timeRecords=[];
    if(event.index==0){
      this.tkdashboard=false;
    }else{
      this.tkdashboard=true;
    }
    // table.clear();
    this.loadTimeData(this.lastTableLazyLoadEvent);
  }

  selectAllFilter(){
    this.selectedRows=this.selectedRows.filter((val:any)=>val.timeRecordStatus=='In Progress')
  }

  
onDateFilterChange(field: any) {
  if(this.filterDatesMatchModes[field]=='betweenDate'){
    this.filterDates[field] =null ;
  }
}

clearDatesFilter(field: any) {
  console.log('Clear date filter',field);
  this.filterDates[field] = null;
  this.dateFilters =this.dateFilters.filter((filter:any) => filter.field !== field);
  this.loadTimeData(this.lastTableLazyLoadEvent);
}
applyDatesFilter(field: any) {
  console.log("apply", this.filterDates[field],this.filterDatesMatchModes[field]);
  let dates=this.filterDates[field]
  const index = this.dateFilters.findIndex((filter:any) => filter.field === field);
  if(index>-1){
    this.dateFilters.splice(index,1);
  }
  if(this.filterDatesMatchModes[field]=='betweenDate'){
    this.dateFilters.push({field:field, operator: "betweenDate", value:  this.filterService.convertDateToFormattedPayloadStr(dates[0]),
                          valueTo:this.filterService.convertDateToFormattedPayloadStr(dates[1])});
  }else{
    this.dateFilters.push({field:field, operator: this.filterDatesMatchModes[field], value:  this.filterService.convertDateToFormattedPayloadStr(dates)});
  }
  this.loadTimeData(this.lastTableLazyLoadEvent);
}

clearAllFilters(table: Table) { 
  this.searchTerm = '';
  this.selectedFilterOption = 'All Time Records';
  this.dateFilters = [];
  Object.keys(this.filterDatesMatchModes).map((field:any)=>this.filterDatesMatchModes[field]='')
  Object.keys(this.filterDates).map((field:any)=>this.filterDatesMatchModes[field]='')
  table.clear();
}

onDateSelect(field: any,event: any) {
  if(this.filterDatesMatchModes[field]=='betweenDate' && this.filterDates[field].length==2 && this.filterDates[field][0] && this.filterDates[field][1]){
    const calendarElement=document.querySelector('.p-calendar');
    if(calendarElement){
     const overlay=document.querySelector('.p-datepicker');
     if(overlay)
      (overlay as HTMLElement).style.display='none';
    }
  }
}
 getFieldInfo(fieldKey: string): FieldInfo | undefined {
    return this.fieldInfoService.getAllFields().find((f: FieldInfo) => f.gridName === 'Time Record' && f.fieldKeyName === fieldKey);
  }

  async exportTimeRecords() {
    // Reuse the same payload builder to ensure consistency
    let payload = await this.buildTimeRecordPayload(this.lastTableLazyLoadEvent || {});

    this.exportLoading = true;
    this.timeRecordService.exportTimeRecords(payload,this.activeTab).subscribe(
      (res: any) => {
        this.exportLoading = false;
        const responseBody = res.body;
        const contentType = res.headers.get('Content-Type');
        
        // Check for ArrayBuffer response
        if (responseBody && responseBody instanceof ArrayBuffer && responseBody.byteLength > 0) {
          const contentDisposition: any = res.headers.get('Content-Disposition');
          let filename = 'time_records_export.xlsx'; // Default to Excel
          
          // Extract filename from Content-Disposition header
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
            }
          } else if (contentType) {
            // If no Content-Disposition, determine extension from Content-Type
            if (contentType.includes('spreadsheetml.sheet') || contentType.includes('vnd.openxmlformats')) {
              filename = 'time_records_export.xlsx';
            } else if (contentType.includes('vnd.ms-excel')) {
              filename = 'time_records_export.xls';
            } else if (contentType.includes('text/csv')) {
              filename = 'time_records_export.csv';
            }
          }
          
          this.downloadFile(responseBody, filename);
        } else {
          console.error('Invalid response format');
        }
      },
      (error) => {
        this.exportLoading = false;
        console.error('Export failed:', error);
      }
    );
  }

  downloadFile(data: ArrayBuffer, filename: string) {
    // Add timestamp to filename if it doesn't already have one
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
    
    const lastDotIndex = filename.lastIndexOf('.');
    const baseName = lastDotIndex !== -1 ? filename.substring(0, lastDotIndex) : filename;
    const extension = lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : 'csv';
    
    // Check if filename already has a timestamp pattern
    if (!baseName.match(/\d{4}-\d{2}-\d{2}_\d{2}-\d{2}-\d{2}/)) {
      filename = `${baseName}_${timestamp}.${extension}`;
    }
    
    // Determine MIME type based on file extension
    let mimeType = 'application/octet-stream';
    if (extension === 'xlsx') {
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (extension === 'xls') {
      mimeType = 'application/vnd.ms-excel';
    } else if (extension === 'csv') {
      mimeType = 'text/csv';
    }
    
    const blob = new Blob([data], { type: mimeType });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename;
    downloadLink.click();
    URL.revokeObjectURL(downloadLink.href);
  }

  restoreSavedState(saved: any) {
      const event = saved.event;
      const cf = saved.customFilters;
  
      // Restore custom component filters
      this.dateFilters = cf.dateFilters;
      this.selectedFilterOption = cf.selectedFilterOption;
      this.searchTerm = cf.searchTerm;
  
      setTimeout(() => {
        if (this.timeRecordTable) {
           const filtersAreValid = event.filters && Object.keys(event.filters).length > 0;

          // 2. Assign filters: Use saved filters if valid, otherwise use the captured default filters.
          if (filtersAreValid) {
            this.timeRecordTable.filters = event.filters;
          } else if (Object.keys(this.defaultFilters).length > 0) {
            // 🔥 Use the default structure as a fallback to prevent empty filter popups
            this.timeRecordTable.filters = this.defaultFilters;
          }

          this.timeRecordTable.sortField = event.sortField ?? '';
          this.timeRecordTable.sortOrder = event.sortOrder ?? 0;

          this.timeRecordTable.sortSingle();

          this.timeRecordTable.first = event.first ?? 0;
          this.timeRecordTable.rows = event.rows ?? 10;

          this.timeRecordTable.onLazyLoad.emit(event);
        }
      }, 60);
  
      this.initialLoadDone = true;
    }
  
    saveState(event: LazyLoadEvent) {
      if (this.tasksgridPrjFilter) {
        return;
      }
      const state: SavedTableState = {
        event: {
          first: event.first,
          rows: event.rows,
          sortField: event.sortField,
          sortOrder: event.sortOrder,
          filters: event.filters
        },
        customFilters: {
          selectedFilterOption: this.selectedFilterOption,
          dateFilters: this.dateFilters,
          searchTerm: this.searchTerm
        }
      };
  
      this.tableStateService.saveState("timerecord_grid"+this.activeTab, this.auth.jwtData.email, state);
    }
    ngAfterViewInit() {
    // Capture the table's initial, un-filtered state structure
    // This needs a slight delay to ensure the table component is ready.
    setTimeout(() => {
      if (this.timeRecordTable && this.timeRecordTable.filters) {
        // Deep clone the initial filters to use as a fallback
        this.defaultFilters = JSON.parse(JSON.stringify(this.timeRecordTable.filters));
      }
    });
  }
  
  handleTableTabChange(event: any) {
    if (event.index == 0) {
      this.activeTab = "default";
    } else {
      this.activeTab = "user";
    }
    this.applyTabColumns();
  }

  applyTabColumns(): void {
    // 1. Determine which reference list to use based on the tab
    const referenceList = this.activeTab === "default" ? this.defaultCols : this.customCols;

    // 2. Handle empty custom columns case
    if (this.activeTab !== "default" && (!referenceList || referenceList.length === 0)) {
        this.cols = [];
        return;
    }

    // 3. Map over the reference list to ensure its order is preserved
    this.cols = referenceList
        .map((ref: any) => {
            // Find the master definition in tableCols matching the reference field
            const masterCol = this.tableCols.find(col => col.field === ref.fieldKeyName);

            // Return the merged column with visible true, or null if not found
            return masterCol ? { ...masterCol, visible: true } : null;
        })
        .filter(col => col !== null); // Clean up any missing column matches

    this.cdr.detectChanges();

    if(this.resetcustomFilter && this.activeTab === "user"){
      this.clearAllFilters(this.timeRecordTable);
      this.resetcustomFilter=false;
    }else{
      const saved = this.tasksgridPrjFilter ? null : this.tableStateService.getState('timerecord_grid'+this.activeTab, this.auth.jwtData.email) as SavedTableState;

      if (saved) {
        this.restoreSavedState(saved);
      }
    }
  }
  fetchColumnSettings(): void {
    this.timeRecordService.getTableSettings().subscribe(apiResponse => {
      apiResponse.defaultGridFields = this.sortByDisplayOrder(apiResponse.defaultGridFields || []);
      apiResponse.userViewGridFields = this.sortByDisplayOrder(apiResponse.userViewGridFields || []);
      apiResponse.availableFields = this.sortByDisplayOrder(apiResponse.availableFields || []);
      // Store the full objects, not just fieldKeyName
      this.defaultCols = Array.isArray(apiResponse?.defaultGridFields)
        ? apiResponse.defaultGridFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.customCols = Array.isArray(apiResponse?.userViewGridFields)
        ? apiResponse.userViewGridFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.availableColumns = Array.isArray(apiResponse?.availableFields)
        ? apiResponse.availableFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.applyTabColumns();
    });
  }
  

  isVisible(field: string): boolean {
    if (!field || !Array.isArray(this.cols)) return false;
    try{
      return this.cols.filter((c: any) =>  c.field === field && c.visible).length > 0;
    }
    catch(error){
      console.log('Error checking visibility for field:', field, this.cols);
      console.error('Error in isVisible:', error);
      return false;
    }
  }

  viewGridSettings() {
    this.gridSettingsDialog = true;
  }

  closeSettingsDialog() {
    this.gridSettingsDialog = false;
    this.fetchColumnSettings();
  }
  sortByDisplayOrder<T extends { displayOrder?: number }>(arr: T[]): T[] {
    return [...arr].sort((a, b) => {
      const aOrder = a.displayOrder ?? Number.MAX_SAFE_INTEGER;
      const bOrder = b.displayOrder ?? Number.MAX_SAFE_INTEGER;
      return aOrder - bOrder;
    });
  }

  saveCustomSettings() {
    // this.handleTableTabChange({ index: 1 });
    this.gridSettingsDialog = false;
    this.resetcustomFilter=true;
  }

  openGridSettings() {
    this.gridSettingsDialog = true;
  }

  getDefaultGridColumns(): any[] {
    // Hard code default columns for Project Name and ID
    return [
      {
        fieldKeyName: 'projectName',
        fieldName: 'Project Name'
      },
      {
        fieldKeyName: 'taskName',
        fieldName: 'Task Name'
      },
      {
        fieldKeyName: 'taskId',
        fieldName: 'Task ID'
      }
    ];
  }

  showAuditData(timeRecordData:any,fieldName: string,header:string) {
    this.auditTableName='al_project_tasks';
    this.auditField=this.getAuditFieldMapping(fieldName);
    this.auditRecordId=timeRecordData.taskId;
    if(fieldName=='timeRecordStatus'){
      this.auditTableName='al_time_record';
      this.auditRecordId=timeRecordData.id;
    }
    this.auditTitle = "Audit History for " + header +" ["+this.auditRecordId+"]";
    this.auditDialog = true;
  }

  closeAuditDialog() {
    this.auditDialog = false;
    this.auditRecordId=null;
    this.auditField='';
  }

  
  getAuditFieldMapping(fieldName: string): string {
    const mapping: { [key: string]: string } = {
      'taskDueDate': 'taskDueDate',
      'taskStatusCode': 'statusCode',
      'isCompleted': 'isCompleted',
      "timeRecordStatus": 'timeRecStatus',
    };
    return mapping[fieldName] || fieldName;
  }

  getQuantityStrList(){
    const val = this.timeForm.get('quantityStr')?.value;
    return val ? val.toString().split(',').map((item: string) => item.trim()).filter((item: string) => item) : [];
  }

}